/**
 * Replic mixin
 *
 * Добавляет логику для работы с репликами
 *
 */

import { GLOBAL_EVENTS } from '@/App.vue';

export default {
  staticData: () => ({
    replicTimeout: null,
  }),
  created() {
    this.initReplicActions();
  },
  methods: {
    abortRobotReplic() {
      return this.$robot.dialogService.abortRobotReplic();
    },
    sayAnswer(answer) {
      this.$robot.dialogService.sayAnswerByData(answer, true);
    },
    onRobotReplicStart(text) {
      this.onReplicUpdated?.(text);
      this.clearReplicTimeout();
      this.$root.$emit(GLOBAL_EVENTS.ROBOT_REPLIC_START, text);
    },
    onRobotReplicFinish() {
      this.clearReplic();
      this.$root.$emit(GLOBAL_EVENTS.ROBOT_REPLIC_FINISH);
    },
    onUserReplic(text, isFinish) {
      this.onReplicUpdated?.(text);
      this.clearReplicTimeout();
      if (isFinish) {
        this.replicTimeout = window.setTimeout(this.clearReplic, 1000);
        this.$root.$emit(GLOBAL_EVENTS.USER_REPLIC_FINISH, text);
      }
    },
    clearReplic() {
      this.onReplicUpdated?.('');
    },
    clearReplicTimeout() {
      window.clearTimeout(this.replicTimeout);
    },
    initReplicActions() {
      const robotActions = [
        this.$robot.dialogService.onRobotReplicStart(this.onRobotReplicStart),
        this.$robot.dialogService.onRobotReplicFinish(this.onRobotReplicFinish),
        this.$robot.dialogService.onUserReplic(this.onUserReplic),
        this.$robot.dialogService.onLoadAnswer(this.sayAnswer),
      ];
      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
        this.clearReplicTimeout();
      });
    },
  },
};
